<!-- <ag-grid-angular
    id='lhGrid'
    class="ag-theme-material ag-table"
    style="width: 100%; height: 100%;"
    [rowData]="rows"
    [columnDefs]="cols"
    [pagination]="true"
    [gridOptions]="gridOptions"
    [defaultColDef]="defaultColDef"
    [editType]="editType"
    [paginationPageSize]="paginationPageSize"
    [frameworkComponents]="frameworkComponents"
    (cellClicked)="onCellClicked($event)"
    (gridReady)="onGridReady($event)">
</ag-grid-angular> -->
<ag-grid-angular
    id='lhGrid'
    class="ag-theme-material ag-table"
    style="width: 100%; height: 100%;"
    [rowData]="rows"
    [columnDefs]="cols"
    [pagination]="true"
    [gridOptions]="gridOptions"
    [defaultColDef]="defaultColDef"
    [editType]="editType"
    [paginationPageSize]="paginationPageSize"
    (cellClicked)="onCellClicked($event)"
    (gridReady)="onGridReady($event)">
</ag-grid-angular>
